import { render, staticRenderFns } from "./HpadD_Items.vue?vue&type=template&id=2ed37ec1"
import script from "./HpadD_Items.vue?vue&type=script&lang=js"
export * from "./HpadD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports